import "./SulfuricBurn.module.css";
import Header from "@/reusable_sections/Header";
import Combustion from "./sections/Combustion";
import SulfurBurning from "./sections/SulfurBurning";
import Benefits from "./sections/Benefits";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function SulfuricBurnPage() {
  return <div>
      <Header />
      <Combustion />
      <SulfurBurning />
      <Benefits />
      <CallToAction />
      <Footer />
    </div>;
}